import { getProperDate, getProperDateWithTime } from '@lib';

export function normalizeSimpleApiData(data) {
  return {
    ...data,
    trackingDate: data?.trackingDate && getProperDateWithTime(data?.trackingDate),
    wagonSendDate: data?.wagonSendDate && getProperDate(data?.wagonSendDate),
  };
}
